import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getCountries } from "./Axios";

const CountrySelect = props => {
  const [countries, setCountries] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "country");
  };

  useEffect(() => {
    getCountries((response) => {
      if (response && response.data) {
        const newCountries = response.data.map((country) => ({
          value: country.id,
          label: country.name,
          uniqueIdentifier: country.unique_identifier,
        }));
        setCountries(newCountries);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-country-search"
      onChange={handleChange}
      options={countries}
      placeholder="Buscar y seleccionar un país"
      value={
        countries.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default CountrySelect;

